import sharedConstants from "@lib/shared_constants.json";

const {
  COMMUNICATION: {
    WHATS_APP: { MEDIA: mediaConstants },
  },
} = sharedConstants;

export type TemplateComponentHeaderFormatText = "text";
export type TemplateComponentHeaderFormatMedia = "image" | "video" | "document";

export type TemplateComponentHeader = {
  header_format: TemplateComponentHeaderFormatText | TemplateComponentHeaderFormatMedia;
  text?: string;
  examples?: string[];
};

export type TemplateComponentBody = {
  text: string;
  examples?: string[];
};

export type TemplateComponentFooter = {
  text: string;
};

export type TemplateComponentButtonTypeUrl = "url";
export type TemplateComponentButtonUrl = {
  button_type: TemplateComponentButtonTypeUrl;
  text: string;
  url: string;
  examples?: string[];
};

export type TemplateComponentButtonTypePhoneNumber = "phone-number";
export type TemplateComponentButtonPhoneNumber = {
  button_type: TemplateComponentButtonTypePhoneNumber;
  text: string;
  phone_number: string;
  examples?: string[];
};

export type TemplateComponentButtonTypeQuickReply = "quick-reply";
export type TemplateComponentButtonTypeCopyCode = "copy-code";
export type TemplateComponentButtonTypeOther =
  | TemplateComponentButtonTypeQuickReply
  | TemplateComponentButtonTypeCopyCode;
export type TemplateComponentButtonOther = {
  button_type: TemplateComponentButtonTypeQuickReply | TemplateComponentButtonTypeCopyCode;
  text: string;
  examples?: string[];
};

export type TemplateComponentButton =
  | TemplateComponentButtonUrl
  | TemplateComponentButtonPhoneNumber
  | TemplateComponentButtonOther;

export interface TemplateComponentsCarouselCard {
  header?: TemplateComponentHeader;
  body?: TemplateComponentBody;
  buttons?: TemplateComponentButton[];
}

export interface TemplateComponents {
  header?: TemplateComponentHeader;
  body?: TemplateComponentBody;
  footer?: TemplateComponentFooter;
  buttons?: TemplateComponentButton[];
  carousel_cards?: TemplateComponentsCarouselCard[];
}

export interface TemplatePrefillContentCarouselCard {
  header_media_type?: typeof mediaConstants.IMAGE.MEDIA_TYPE_KEY | typeof mediaConstants.VIDEO.MEDIA_TYPE_KEY;
  header_media_uri?: string;
  header_asset_id?: string;
  header_liquid_variables?: (string | null)[];
  body_liquid_variables?: (string | null)[];
  button_liquid_variables?: (string | null)[];
}

export interface TemplatePrefillContent {
  header_media_type?:
    | typeof mediaConstants.IMAGE.MEDIA_TYPE_KEY
    | typeof mediaConstants.VIDEO.MEDIA_TYPE_KEY
    | typeof mediaConstants.DOCUMENT.MEDIA_TYPE_KEY;
  header_media_uri?: string;
  header_asset_id?: string;
  header_liquid_variables?: (string | null)[];
  body_liquid_variables?: (string | null)[];
  button_liquid_variables?: (string | null)[];
  carousel_cards?: TemplatePrefillContentCarouselCard[];
}

export interface PostWhatsAppMessageTemplateRequest {
  external_account_ids: string[];
  template: {
    name: string;
    language: string;
    category: string;
    subtype: string;
    components?: TemplateComponents;
    prefill_content?: TemplatePrefillContent;
    /** Whether click tracking is enabled (maps to backend `cte` field) */
    click_tracking_enabled?: boolean;
    /** Custom domain for link shortening (maps to backend `cd` field) */
    custom_domain?: string;
  };
}

export interface MetaApiErrorResponse {
  error: {
    message: string;
    error_user_title?: string;
    error_user_msg?: string;
  };
}

export type PostWhatsAppMessageTemplateResponseCommonResult = {
  external_account_id?: string;
};

export type PostWhatsAppMessageTemplateResponseSuccessResult = {
  success: true;
};

export type PostWhatsAppMessageTemplateResponseErrorResult = {
  success: false;
  error: string;
  meta_api_response: string;
};

export type PostWhatsAppMessageTemplateResponseResult = PostWhatsAppMessageTemplateResponseCommonResult &
  (PostWhatsAppMessageTemplateResponseSuccessResult | PostWhatsAppMessageTemplateResponseErrorResult);

export interface PostWhatsAppMessageTemplateResponse {
  overall_success: boolean;
  results: PostWhatsAppMessageTemplateResponseResult[];
}

export interface PostEngagementAppGroupIdWhatsAppMessageTemplatesProps {
  appGroupId: string;
  requestBody: PostWhatsAppMessageTemplateRequest;
}
